import defaultTheme from './defaultTheme';
const lowesTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#004990', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#004990', background: '#004990' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#004990' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#004990', border: '#004990', background: '#004990' }), field: {
        focus: '#004990',
        label: '#004990',
        icon: '#004990',
    } });
export default lowesTheme;
